<template>
  <div class="yoyo-container mx-auto pb-[env(safe-area-inset-bottom)]">
    <navBar :title="$t('products.payNavTitle')" />

    <!-- Content -->
    <div class="pb-4">
      <AddressForm
        ref="addressForm"
        :addressData="addressData"
        :showAddress="hasSim"
        @register-check="handleRegisterCheck"
        @address-click="handleAddressClick" />
      <PayProduct :products="settleProducts" />
      <PaymentSummary
        :priceInfo="settlementData.price"
        :settlementDataErrCode="settlementDataErrCode"
        @yoyo-used="handleYoYoUsed"
        @coupon-selected="handleCouponSelected"
        @reset="handleReset"
        :showShippingFee="hasSim" />
      <PaymentMethod :bankInfo="bankData" ref="paymentMethod" />
    </div>

    <div class="h-17"></div>

    <!-- 结算按钮 -->
    <div class="fixed z-50 h-17 bottom-0 left-0 right-0 pb-[env(safe-area-inset-bottom)] yoyo-container mx-auto">
      <div class="flex items-center space-x-3 w-full h-17 lg:mx-4 lg:w-[calc(100%-2rem)] bg-white border-t border-gray-200 py-3 px-3">
        <div class="flex-1 text-right mr-4">
          <div class="text-lg font-bold text-[#ff7a00]">RM {{ formatToYuan(settlementData.price && settlementData.price.payPrice) }}</div>
          <div class="text-sm text-gray-500" v-if="isRegister != null && !isLoggedIn">
            <div v-if="isRegister == false" class="flex items-center justify-end">
              <van-button type="primary" size="mini" plain color="#ff7a00" @click="handleLogin">
                {{ $t("products.registerMember") }}
              </van-button>
              <span class="ml-1">{{ $t("products.registerMemberDiscount") }}</span>
            </div>
            <div v-if="isRegister == true" class="flex items-center justify-end">
              <van-button type="primary" size="mini" plain color="#ff7a00" @click="handleLogin">
                {{ $t("products.loginMember") }}
              </van-button>
              <span class="ml-1">{{ $t("products.loginMemberDiscount") }}</span>
              <span>{{ settlementData.givePoint }}</span>
              <span>{{ $t("products.yoyoCoins") }}</span>
            </div>
          </div>
        </div>

        <!-- 结算按钮 -->
        <van-button type="primary" class="rounded-xl w-24 h-8" color="#ff7a00" @click="handleCheckout">
          {{ $t("products.checkout") }}
        </van-button>
      </div>
    </div>

    <CommonDialog
      :visible.sync="waitingForPayment"
      :title="$t('pay.title')"
      :buttons="[{ text: $t('common.confirm'), type: 'primary', action: 'submit' }]"
      @button-click="handleWaitingForPaymentClose"
      @close="handleWaitingForPaymentClose">
      <div class="text-center">
        <div class="mb-4">
          {{ $t("pay.waitingForPayment") }}
        </div>
      </div>
    </CommonDialog>
    <CommonDialog
      :visible.sync="orderSuccess"
      :title="$t('pay.title')"
      :buttons="[{ text: $t('common.confirm'), type: 'primary', action: 'submit' }]"
      @button-click="handleOrderSuccess"
      @close="handleOrderSuccessClose">
      <div class="text-center">
        <div class="mb-4">
          {{ $t("pay.orderSuccess") }}
        </div>
      </div>
    </CommonDialog>
  </div>
</template>

<script>
import { Toast } from "vant"
import AddressForm from "@/components/products/AddressForm.vue"
import PayProduct from "@/components/products/PayProduct.vue"
import PaymentSummary from "@/components/products/PaymentSummary.vue"
// import PaymentMethod from "@/components/products/PaymentMethod.vue"
import PaymentMethod from "@/components/products/PaymentMethodNew.vue"
import { mapGetters, mapMutations } from "vuex"
import { getDefaultAddress, getDefaultBank, getSettlement, createOrderNew, getOrderStatus } from "@/apis/pay"
import BigNumber from "bignumber.js"
import { formatToYuan } from "@/utils/common"

export default {
  name: "PayNew",
  components: {
    AddressForm,
    PayProduct,
    PaymentSummary,
    PaymentMethod,
  },
  data() {
    return {
      backSrc: require("@/assets/images/back.png"),
      yoyoUsed: false, //是否使用YoYo币
      couponId: "", //优惠券id
      paymentData: null,
      addressData: null,
      bankData: null,
      hasSim: false,
      settleProducts: [], //结算商品
      settlementData: {},
      isRegister: null,
      formatToYuan,
      isLoading: false,
      settlementDataErrCode: "",
      orderId: "",
      waitingForPayment: false,
      orderSuccess: false,
      usePoint: 0,
      timer: null,
      startTime: null,
      count: 0,
      payInfo: {}, // 支付信息
      country: "",
      city: "",
      settleAddressData: {}
    }
  },
  computed: {
    ...mapGetters({
      isZh: "lang/isZh",
      isLoggedIn: "auth/isLoggedIn",
    }),
    shouldExecute() {
      return this.country && this.country
    },
  },
  methods: {
    ...mapMutations({
      setLoginDialogVisible: "auth/SET_LOGIN_DIALOG_VISIBLE",
    }),
    handleYoYoUsed(discount, isRefresh, usePoint) {
      this.yoyoUsed = discount
      this.usePoint = usePoint
      if (isRefresh) {
        this.getSettlementData(this.settleAddressData)
      }
    },
    handleCouponSelected(coupon, isRefresh) {
      this.couponId = coupon
      if (isRefresh) {
        this.getSettlementData(this.settleAddressData)
      }
    },
    handleAddressClick(address) {
      console.log("address :>> ", address)
      this.settleAddressData = address
      this.getSettlementData(address)
    },
    async handleCheckout() {
      // 验证地址表单
      if (!this.$refs.addressForm.validateForm()) {
        Toast(this.$t("products.completeShippingInfo"))
        return
      }

      // // 验证支付方式
      if (!this.$refs.paymentMethod.validatePayment()) {
        Toast(this.$t("products.completePaymentInfo"))
        return
      }

      // 获取地址数据
      const addressData = this.$refs.addressForm.getFormData()

      // 获取支付数据
      const paymentData = this.$refs.paymentMethod.getPaymentData()
      console.log("paymentData :>> ", paymentData)
      const items = this.settleProducts.map((item) => {
        return {
          skuId: item.sku,
          count: item.count,
          cartId: item.cartId || "",
        }
      })
      // return
      const params = {
        items: items, // 商品信息
        couponId: this.couponId || "", // 优惠券id
        usePoint: this.yoyoUsed ? this.usePoint : 0, // 是否使用YoYo币
        receiverAddress: addressData.address, // 收获地址
        receiverCountry: addressData.receiverCountry, // 收获国家
        receiverCity: addressData.receiverCity, // 收获城市
        receiverZipcode: addressData.receiverZipcode, // 收获邮编
        receiverName: addressData.name, // 收获人姓名
        receiverMobile: addressData.countryCode + " " + addressData.mobile, // 收获人手机号
        email: addressData.email, // 收获人邮箱
        receivePromotion: addressData.subscribeMarketing ? 1 : 0, // 是否订阅促销
        bankName: paymentData.form.name, // 银行卡名称
        bankCardNo: paymentData.form.cardNo, // 银行卡号
        bankExpireDate: paymentData.form.expireDate, // 有效期
        bankChecksum: paymentData.form.checksum, // 校验码
        bankSave: paymentData.form.saveCard ? true : false, // 是否保存银行卡
      }

      this.payInfo = params
      console.log("this.payInfo :>> ", this.payInfo)
      // return

      try {
        Toast.loading({
          forbidClick: true,
          overlay: true,
          duration: 60000,
        })
        const orderData = await createOrderNew(params)
        const payParams = orderData.data.payParams
        this.createAndClickPayButton(payParams, paymentData.channel)
      } catch (error) {
        Toast.clear()
        console.log(error)
      } finally {
      }
    },
    createAndClickPayButton(payParams, channel) {
      try {
        console.log("payParams :>> ", payParams)
        const { amount, billDesc, billEmail, billMobile, billName, currency, merchantID, orderId, vscode } = payParams || {}

        // 移除已存在的按钮（避免重复）
        const existingButton = document.getElementById("molpay-button")
        if (existingButton) {
          existingButton.remove()
        }

        // 创建新的支付按钮
        const button = document.createElement("button")
        button.id = "molpay-button"
        button.style.display = "none" // 不显示在页面上

        // 设置所有必需的属性
        button.setAttribute("data-toggle", "molpayseamless")
        button.setAttribute("data-mpschannel", channel)
        button.setAttribute("data-mpsamount", amount)
        button.setAttribute("data-mpsbill_desc", billDesc || "buy goods")
        button.setAttribute("data-mpsbill_email", billEmail || "")
        button.setAttribute("data-mpsbill_mobile", billMobile || "")
        button.setAttribute("data-mpsbill_name", billName || "")
        button.setAttribute("data-mpscurrency", currency)
        button.setAttribute("data-mpsmerchantid", merchantID)
        button.setAttribute("data-mpsorderid", orderId)
        button.setAttribute("data-mpsvcode", vscode)

        // button.setAttribute("data-mpsreturnurl", "https://www.yoyotravel.my/pay-success")

        // 添加到 body
        document.body.appendChild(button)

        // 调试：检查属性是否正确设置
        console.log("创建的按钮属性:", {
          name: button.getAttribute("data-mpsbill_name"),
          desc: button.getAttribute("data-mpsbill_desc"),
          email: button.getAttribute("data-mpsbill_email"),
          mobile: button.getAttribute("data-mpsbill_mobile"),
          vcode: button.getAttribute("data-mpsvcode"),
          orderId: button.getAttribute("data-mpsorderid"),
          merchantID: button.getAttribute("data-mpsmerchantid"),
          currency: button.getAttribute("data-mpscurrency"),
          amount: button.getAttribute("data-mpsamount"),
          channel: button.getAttribute("data-mpschannel"),
        })
        // return
        // 触发点击
        this.$nextTick(() => {
          try {
            button.click()
            console.log("支付按钮已触发")

            // 点击后可以移除按钮
            setTimeout(() => {
              button.remove()
              Toast.clear()
            }, 1000)
          } catch (error) {
            Toast.clear()
            console.error("触发支付失败:", error)
          }
        })
      } catch (error) {
        Toast.clear()
        console.log("error :>> ", error)
      }
    },
    async getOrderStatusFn() {
      // 1秒钟查询一次,直到status为10或者查询次数为120结束
      try {
        // 1秒钟查询一次,直到status为10或者查询次数为120结束
        if (this.count >= 120) {
          clearTimeout(this.timer) // 清理定时器
          return
        }
        this.count++
        const res = await getOrderStatus({ id: this.orderId })
        if (res.data.status === 10) {
          this.waitingForPayment = false
          this.orderSuccess = true
          clearTimeout(this.timer) // 成功时清理定时器
          return
        }
        this.timer = setTimeout(() => {
          this.getOrderStatusFn()
        }, 1500)
      } catch (error) {
        console.log("error", error)
      }
    },
    async getDefaultData() {
      console.log('this.isLoggedIn :>> ', this.isLoggedIn);
      if (!this.isLoggedIn) {
        this.getSettlementData({ receiverCity: '', receiverCountry: '' })
        return
      }
      try {
        const addressData = await getDefaultAddress()
        console.log("addressData.data :>> ", addressData.data)
        // const bankData = await getDefaultBank()
        this.addressData = addressData.data || {}
        this.settleAddressData = { receiverCity: this.addressData.city, receiverCountry: this.addressData.country }
        // this.bankData = bankData.data
        // this.country = addressData.data.country
        // this.city = addressData.data.city
        this.getSettlementData(this.settleAddressData)
      } catch (error) {
        this.getSettlementData({ receiverCity: '', receiverCountry: '' })
        console.log(error)
      }
    },
    async getSettlementData(address) {
      this.settlementDataErrCode = ''
      console.log("this.settleProducts :>> ", this.settleProducts)
      try {
        const items = this.settleProducts.map((item) => {
          if (item.type === "SIM") {
            this.hasSim = true
          }
          // console.log('item :>> ', item);
          return {
            skuId: item.sku,
            count: item.count,
            cartId: "",
          }
        })
        // console.log('items :>> ', items);
        const params = {
          items: items,
          couponId: this.couponId || "",
          usePoint: this.yoyoUsed ? this.usePoint : 0,
          receiverCountry: address?.receiverCountry || "",
          receiverCity: address?.receiverCity || "",
          type: '0'
        }
        const res = await getSettlement(params)
        let data = res.data || {}
        data.price.userPoint = res.data.userPoint
        data.price.totalPoint = res.data.totalPoint
        this.settlementData = data
        this.settleProducts = res.data.items.map((item) => {
          if (item.type === "SIM") {
            this.hasSim = true
          }
          return {
            ...item,
            count: item.count,
            day: item.dayName,
            marketPrice: item.marketPrice,
            picUrl: process.env.VUE_APP_IMAGE_URL + item.picUrl,
            type: item.spuType || "eSIM",
            region: item.spuType + " " + item.spuName,
            regionEn: item.spuType + " " + item.spuNameEn,
            selectedText: item.packageName + " " + item.dayName,
            selectedTextEn: item.packageNameEn + " " + item.dayNameEn,
            price: item.price,
            sku: item.skuId,
          }
        })
      } catch (error) {
        // console.log("error :>> ", error)
        const code = error.code
        this.settlementDataErrCode = code
        if (code === 'ECONNABORTED') {
          // this.settlementData.price ? (this.settlementData.price.payPrice = 0) : this.settlementData = { price: { payPrice: 0 } }
          this.handleReset()
          Toast.fail({
            message: this.$t("products.settleErr"),
            forbidClick: true,
            duration: 3000,
          })

        } 
        // this.settlementDataErrCode = code
        
      }
    },
    handleReset() {
      console.log('this.settlementData.price :>> ', this.settlementData.price);
      const price = this.settlementData.price || {}
      const totalPrice = price.totalPrice || 0
      const deliveryPrice = price.deliveryPrice || 0
      const payPrice = new BigNumber(totalPrice).plus(deliveryPrice).toNumber()
      this.settlementData.price ? (this.settlementData.price.payPrice = payPrice) : this.settlementData = { price: { payPrice: payPrice } }
    },
    handleRegisterCheck(isRegister) {
      this.isRegister = isRegister
    },
    handleLogin() {
      this.setLoginDialogVisible(true)
    },
    handleWaitingForPaymentClose() {
      this.waitingForPayment = false
    },
    handleOrderSuccess() {
      this.handleOrderSuccessClose()
      this.$router.push({
        name: "orderDetail",
        query: {
          orderId: this.orderId,
        },
      })
    },
    handleOrderSuccessClose() {
      this.orderSuccess = false
    },
  },
  watch: {

  },
  created() {
    this.settleProducts = JSON.parse(localStorage.getItem("yoyotravel_settleData"))
    this.getDefaultData()
  },
  beforeDestroy() {
    console.log("清除定时器 :>> ")
    // 清除轮询查询
    clearTimeout(this.timer)
    clearTimeout(this.startTime)
  },
}
</script>

<style scoped></style>
